export const environment = {
    production: true,
    apiUrl: 'https://pocketlist-api-dev.azurewebsites.net'
  };
